import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateContactCompany, privateContactCompaniesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IByPrivateContactCompanyState } from './types';

const PRIVATE_CONTACT_COMPANY_MODULE = 'privateContactCompany';

const state: IByPrivateContactCompanyState = {
    byContact: new Map()
};

const dataObjectModule = getDataObjectsModule<IPrivateContactCompany>(privateContactCompaniesManager, 3);
const searchModule = getSearchModule<IPrivateContactCompany>(privateContactCompaniesManager);

const privateContactCompanyModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(PRIVATE_CONTACT_COMPANY_MODULE, privateContactCompanyModuleInstance);

export { PRIVATE_CONTACT_COMPANY_MODULE };
